import { SystemStyleObject } from "@chakra-ui/react";

export const individualTableCTACss: SystemStyleObject = {
  width: "52px",
  height: "40px",
  boxShadow: "0px 0px 0px 1px #122B6914",
  borderRadius: "8px",
  padding: "10px",
  color: "#1A202C",
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 600,
};

export const individualTypeCss: SystemStyleObject = {
  height: "22px",
  borderRadius: "16px",
  padding: "2px 8px",
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "18px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const individualTableColumnCss: SystemStyleObject = {
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 400,
  color: "#667085",
};

export const viewDetailsCardCss: SystemStyleObject = {
  borderRadius: "20px",
  backgroundColor: "#ffffff",
  padding: "24px",
};

export const viewDetailsCard1Css: SystemStyleObject = {
  width: "100%",
  maxWidth: "57%",
  // maxWidth: "57%",
  //   height: "71vh",
  //   overflow: "hidden scroll",
};

export const viewDetailsCard2Css: SystemStyleObject = {
  width: "100%",
  maxWidth: "41.5%",
  // maxWidth: "41.5%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

export const upgradeLimitBtnCss: SystemStyleObject = {
  height: "40px",
  borderRadius: "8px",
  width: "137px",
  padding: "10px 18px",
  border: "1px solid #D0D5DD",
  boxShadow: "0px 1px 2px 0px #1018280D",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "20px",
  color: "#101828",
};

export const viewDetailsSeparatorCss: SystemStyleObject = {
  width: "100%",
  height: "1px",
  display: "flex",
  alignItems: "center",
  margin: "24px 0",
  backgroundColor: "#EAECF0",
};

export const viewDetailsSeparatorCssNoMargin: SystemStyleObject = {
  width: "100%",
  height: "1px",
  display: "flex",
  alignItems: "center",
  // margin: "24px 0",
  backgroundColor: "#EAECF0",
};

export const viewDetailDownloadLinkCss: SystemStyleObject = {
  color: "#00535C",
  fontSize: "14px",
  lineHeight: "19.12px",
  fontWeight: "600",
  textDecoration: "underline",
};

export const viewBusinessCustomerBtnCss: SystemStyleObject = {
  width: "100%",
  height: "44px",
  borderRadius: "8px",
  padding: "10px 18px",
  display: "flex",
  alignItems: "center",
  border: "1px solid #D0D5DD",
  boxShadow: "0px 1px 2px 0px #1018280D",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 600,
  color: "#344054",
};

export const viewDetailToolTipCss: SystemStyleObject = {
  backgroundColor: "#FFFFFF",
  padding: "10px 20px",
  boxShadow: "0px 4px 20px 0px #0000001A",
  borderRadius: "10px",
  width: "396px",
  fontSize: "16px",
  lineHeight: "23px",
  color: "#000000",
};

export const approveOrRejectNewLimitModalHeaderCss: SystemStyleObject = {
  marginBottom: 0,
};
